import React from 'react'
import { Link } from 'react-router-dom'
import './PrivacyPolicy.css'

const PrivacyPolicy = () => (
  <div className="privacy-page">
    <div className="privacy-content">
      <Link to="/" className="privacy-back-link">
        ← Voltar ao início
      </Link>
      <h1>Política de Privacidade</h1>
      <p className="privacy-updated">Última atualização: julho de 2026</p>

      <p>
        Este site (<strong>jarder.dev</strong>) pertence a Jarder Silva. Esta
        política explica quais dados são coletados durante a sua visita e
        como eles são usados.
      </p>

      <h2>Dados de navegação e cookies</h2>
      <p>
        Usamos o Google Analytics para entender, de forma agregada, quantas
        pessoas visitam o site e quais páginas são mais acessadas. O Google
        Analytics usa cookies e coleta informações como endereço IP
        (anonimizado), tipo de navegador e páginas visitadas.
      </p>
      <p>
        O site também pode exibir anúncios via Google AdSense. O Google e
        seus parceiros podem usar cookies (incluindo o cookie DoubleClick)
        para exibir anúncios com base em visitas anteriores a este e a
        outros sites. Você pode desativar a personalização de anúncios nas{' '}
        <a
          href="https://adssettings.google.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          configurações de anúncios do Google
        </a>
        .
      </p>

      <h2>Formulário de contato</h2>
      <p>
        Ao preencher o formulário de contato, o nome, e-mail e mensagem
        informados são usados exclusivamente para responder sua mensagem e
        não são compartilhados com terceiros.
      </p>

      <h2>Ferramentas gratuitas</h2>
      <p>
        As ferramentas da seção <Link to="/ferramentas">/ferramentas</Link>{' '}
        (sorteador de nomes, gerador de cartela de bingo, etc.) processam os
        dados que você digita inteiramente no seu navegador nada é
        enviado para nenhum servidor. Alguns estados (como a marcação da
        cartela de bingo ou o modo retrô) são salvos apenas no{' '}
        <code>localStorage</code> do seu próprio navegador, para manter suas
        preferências caso você atualize a página.
      </p>

      <h2>Seus direitos (LGPD)</h2>
      <p>
        De acordo com a Lei Geral de Proteção de Dados (LGPD), você pode
        solicitar acesso, correção ou exclusão de dados pessoais que tenha
        nos enviado (por exemplo, pelo formulário de contato). Para isso,
        entre em contato pelo e-mail{' '}
        <a href="mailto:jarder7@gmail.com">jarder7@gmail.com</a>.
      </p>

      <h2>Alterações</h2>
      <p>
        Esta política pode ser atualizada periodicamente para refletir
        mudanças no site ou em requisitos legais. A data no topo desta
        página indica a versão mais recente.
      </p>
    </div>
  </div>
)

export default PrivacyPolicy
